import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../deps';

import './BackstageHeroSidebarImage.scss';

export const BackstageHeroSidebarImage = props => {
  const {
    children,
    heroImageIsCircle,
    renderArtworkPlayButton,
    isRightRailActive,
    isCuratorExperienceEnabled,
  } = props;

  const imageClasses = D.createBEM('BackstageHeroSidebarImage', {
    circle: heroImageIsCircle,
    rightRail: isRightRailActive,
    curatorExperienceEnabled: isCuratorExperienceEnabled,
    renderArtworkPlayButton: renderArtworkPlayButton && !heroImageIsCircle,
  });

  return <div className={imageClasses}>{children}</div>;
};

BackstageHeroSidebarImage.propTypes = {
  children: PropTypes.node,
  heroImageIsCircle: PropTypes.bool,
  isRightRailActive: PropTypes.bool,
  isCuratorExperienceEnabled: PropTypes.bool,
  renderArtworkPlayButton: PropTypes.bool,
};

export default BackstageHeroSidebarImage;
